import React, { useState } from "react"
import Carousel from "react-multi-carousel"
import "react-multi-carousel/lib/styles.css"
import CarouselLeft from "../../assets/images/carousel-left.svg"
import CarouselRight from "../../assets/images/carousel-right.svg"
import "./../../styles/component/multi-carousel.scss"
import SVGIcon from "./SVGIcon"

let CarouselComponent = props => {
  let [currentSlide, setCurrentSlide] = useState(0)

  const responsiveAll = {
    allScreen: {
      breakpoint: { max: 4000, min: 0 },
      items: 1,
      slidesToSlide: 1,
    },
  }

  const responsive = {
    desktopLarge: {
      breakpoint: { max: 4000, min: 1400 },
      items: 4,
      slidesToSlide: 4,
    },
    desktopSmall: {
      breakpoint: { max: 1400, min: 1200 },
      items: 3,
      slidesToSlide: 3,
    },

    tabletLarge: {
      breakpoint: { max: 1024, min: 992 },
      items: 2.5,
      slidesToSlide: 2,
    },

    tablet: {
      breakpoint: { max: 992, min: 500 },
      items: 2,
      slidesToSlide: 1,
    },
    mobile: {
      breakpoint: { max: 578, min: 535 },
      items: 1.3,
      slidesToSlide: 1,
    },
    mobile1: {
      breakpoint: { max: 535, min: 495 },
      items: 1.2,
      slidesToSlide: 1,
    },
    mobile2: {
      breakpoint: { max: 495, min: 480 },
      items: 1.15,
      slidesToSlide: 1,
    },
    mobile3: {
      breakpoint: { max: 480, min: 460 },
      items: 1.1,
      slidesToSlide: 1,
    },
    mobile5: {
      breakpoint: { max: 460, min: 435 },
      items: 1.05,
      slidesToSlide: 1,
    },
    mobile4: {
      breakpoint: { max: 435, min: 0 },
      items: 1,
      slidesToSlide: 1,
    },
  }

  const CustomArrow = ({ onClick, ...rest }) => {
    const { func, classes, carouselState } = rest
    setCurrentSlide(
      Math.floor(carouselState.slidesToShow + carouselState.currentSlide)
    )
    return (
      <img
        className={`position-absolute carousel-arrow carousel-arrow-${classes}`}
        onClick={() => onClick()}
        src={func === "Left" ? CarouselLeft : CarouselRight}
        alt="img"
      />
    )
  }

  const CustomButtonGroup = ({ next, previous, goToSlide, ...rest }) => {
    const {
      carouselState: { currentSlide, slidesToShow },
      displayArrow,
    } = rest
    setCurrentSlide(Math.floor(slidesToShow + currentSlide))
    return (
      <>
        <img
          className={`position-absolute carousel-arrow carousel-arrow-left ${!displayArrow &&
            "dspnone"}`}
          onClick={() =>
            currentSlide !== 0 && goToSlide(Math.floor(currentSlide - 1))
          }
          src={CarouselLeft}
          alt="img"
        />
        <img
          className={`position-absolute carousel-arrow carousel-arrow-right ${!displayArrow &&
            "dspnone"}`}
          onClick={() =>
            currentSlide !== props.children.length - 1 &&
            goToSlide(Math.floor(currentSlide + 1))
          }
          src={CarouselRight}
          alt="img"
        />
      </>
    )
  }

  const CustomButtonNew = ({ next, previous, goToSlide, ...rest }) => {
    const {
      carouselState: { currentSlide, slidesToShow },
      displayArrow,
    } = rest
    setCurrentSlide(Math.floor(slidesToShow + currentSlide))
    return (
      <>
        <div
          className={`caro-btn-wrap d-flex justify-content-between position-absolute w-100 mx-auto ${props.customButtonclass ??
            ""}`}
        >
          <button
            className="carousel-btn left prelative"
            onClick={() =>
              currentSlide !== 0 && goToSlide(Math.floor(currentSlide - 1))
            }
          >
            <SVGIcon
              name={`${
                props.arrowClassName ? "arrowLeftNew" : "mspawards/arrow"
              }`}
              className={`arrow ${props.arrowClassName}`}
            />
          </button>

          <button
            className="carousel-btn right prelative"
            onClick={() =>
              currentSlide !== props.children.length - 1 &&
              goToSlide(Math.floor(currentSlide + 1))
            }
          >
            <SVGIcon
              name={`${
                props.arrowClassName ? "arrowRightNew" : "mspawards/arrow"
              }`}
              className={`arrow ${props.arrowClassName}`}
            />
          </button>
        </div>
      </>
    )
  }

  return (
    <div className="multicarousel-wrapper">
      <Carousel
        ssr={props.ssr ? true : false}
        infinite={props.infinite ? true : false}
        partialVisbile={props.partialVisbile ? true : false}
        renderArrowsWhenDisabled={true}
        responsive={
          props.items === 1
            ? responsiveAll
            : props.responsive
            ? props.responsive
            : responsive
        }
        swipeable={props.swipeable ? true : false}
        draggable={props.draggable ? true : false}
        containerClass="multi-carousel"
        // customLeftArrow={<CustomArrow func={"Left"} classes={"left"} />}
        // customRightArrow={<CustomArrow func={"Right"} classes={"right"} />}
        arrows={false}
        customButtonGroup={
          props.customButtonNew ? (
            <CustomButtonNew />
          ) : (
            <CustomButtonGroup
              displayArrow={
                typeof props.displayArrow === "undefined"
                  ? true
                  : props.displayArrow
              }
            />
          )
        }
        customTransition={props.customTransition && props.customTransition}
        beforeChange={props.onChange}
        autoPlay={props.autoPlay ? true : false}
        autoPlaySpeed={props.autoPlaySpeed && props.autoPlaySpeed}
      >
        {props.children}
      </Carousel>
      {props.status && (
        <div className={`Status p14 ${props.statusClassName}`}>
          <p>
            {props.statusText}{" "}
            {currentSlide -
              (props?.paginationDecrement ? 1 : 0) +
              (props?.paginationIncrement ? 1 : 0)}
            /{props.children.length} {props.statusTextRight}
          </p>
        </div>
      )}
    </div>
  )
}

export default CarouselComponent
